import React, { useState, useImperativeHandle, useRef, useEffect, forwardRef } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Document, pdfjs } from "react-pdf";
import { PdfViewer } from "react-pdf-selection";
import { Tooltip, List, ListItem, Avatar, Zoom, ListItemText, ListItemButton, ListItemAvatar, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import pdffile from "../../assets/images/pdf-file.svg";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import nopdf from "../../assets/images/nopdffile.png";
import "../../assets/css/TextLayer.css";
import CloseIcon from "@mui/icons-material/Close";
import ContentLoader from "../content-loader";
import { motion } from "framer-motion";
import docicon from "../../assets/images/docx.jpg";
import excelicon from "../../assets/images/excel.jpg";
import websiteIcon from "../../assets/images/type_website.png";
import nogenfile from "../../assets/images/no_gen_file.png";
import Iframe from "react-iframe";
import MatchPdf from "../matchpdf";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";
import { searchPlugin } from "@react-pdf-viewer/search";

// Import styles
import "@react-pdf-viewer/search/lib/styles/index.css";
import "@react-pdf-viewer/selection-mode/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
// import pdfview from '../../assets/images/Company-Overview.pdf';
// pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
const ReactPdf = forwardRef((props, ref) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  const searchPluginInstance = searchPlugin();
  useEffect(() => {
    const handleMouseUp = () => {
      const selectedText = window.getSelection().toString();
      if (selectedText) {
        setSearchText(selectedText);
      }
    };

    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    changePage: (page) => {
      pageNavigationPluginInstance.jumpToPage(page-1);
    }
  }));

  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [inputPageNumber, setInputPageNumber] = useState(1);
  const [anchorEl3, setAnchorEl3] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedpdf, setSelectedPdf] = useState(null);
  const [isPdfSelected, setIsPdfSelected] = useState(false); // relevant for DocViewer
  const [isWebsiteUrl, setIsWebsiteUrl] = useState(false);
  const pdfContainerRef = useRef(null);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handlePageChange = (e) => {
    const value = parseInt(e.target.value);
    setInputPageNumber(value);
    if (value >= 1 && value <= numPages) {
      setPageNumber(value);
    }
  };
  const handleScroll = () => {
    if (!pdfContainerRef.current) return;

    const { scrollTop, clientHeight, scrollHeight } = pdfContainerRef.current;
    const totalPages = numPages || 0;
    const totalPagesVisible = Math.ceil(scrollHeight / clientHeight);

    // Calculate the maximum scroll position to prevent overflow
    const maxScrollTop = scrollHeight - clientHeight;

    // Calculate the current scroll position as a percentage of total scrollable height
    const scrollPercentage = Math.min(scrollTop / maxScrollTop, 1);

    // Calculate the current page based on scroll percentage
    const currentPage = Math.ceil(scrollPercentage * totalPages);

    // Ensure the current page is within bounds
    const validCurrentPage = Math.max(1, Math.min(currentPage, totalPages));

    setPageNumber(validCurrentPage);
    setInputPageNumber(validCurrentPage);
  };
  const scrollToPage = (page) => {
    if (!pdfContainerRef.current) return;
    const { clientHeight } = pdfContainerRef.current;
    const scrollTo = (page - 1) * clientHeight;
    pdfContainerRef.current.scrollTo({ top: scrollTo, behavior: "smooth" });
  };
  const open3 = Boolean(anchorEl3);
  const handleClick3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClose3 = () => {
    setAnchorEl3(null);
  };
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };
  const closeDrawer = () => {
    setIsOpen(false);
  };

  // Structure of the docs array
  // const docs = useMemo(() => [
  //   {
  //     uri: require("../assets/images/pdf_folder/data.xlsx"),
  //     fileType: 'xlsx',
  //     fileName: 'data.xlsx'
  //   }
  // ], []);

  const [viewerKey, setViewerKey] = useState(0); // reset the viewer key to re-render the docviewer
  const [docs, setDocs] = useState([]); // set the docs to be rendered in the docviewer
  const [website, setWebsite] = useState(null);

  useEffect(() => {
    setViewerKey((prevKey) => prevKey + 1);
  }, [docs]);

  useEffect(() => {
    if (selectedpdf) {
      if (selectedpdf?.knowledge?.doc_type === "url") {
        setWebsite(selectedpdf);
        setIsWebsiteUrl(true);
        setIsPdfSelected(false);
      } else {
        setIsWebsiteUrl(false);
        setWebsite(null);
        const fileName = selectedpdf?.knowledge?.file_name;
        if (!fileName) return;
        const fileParts = fileName?.split(".");
        const fileExtension = fileParts[fileParts?.length - 1];
        setIsPdfSelected(fileExtension === "pdf");
        if (fileExtension !== "pdf") {
          setDocs([{ uri: selectedpdf?.knowledge?.file_path, fileType: fileExtension, fileName: selectedpdf?.knowledge?.file_name }]);
        }
      }
    }
  }, [selectedpdf]);

  useEffect(() => {
    if (props?.pdf) {
      setSelectedPdf({ knowledge: props?.pdf });
    }
  }, [props?.pdf]);

  useEffect(() => {
    if (selectedpdf === null && props?.pdfList.length > 0) {
      props.getSignedPdf(props?.pdfList[props?.pdfList?.length - 1].knowledge._id);
      setSelectedPdf(props?.pdfList[props?.pdfList?.length - 1]);
    }
  }, [props?.pdfList]);

  //document icon display logic start
  const getIcon = (fileName, doc_type) => {
    if (doc_type === "url") {
      return websiteIcon;
    } else if (doc_type === null) {
      const fileParts = fileName?.split(".");
      const fileExtension = fileParts[fileParts?.length - 1];
      if (fileExtension === "pdf") {
        return pdffile;
      } else if (fileExtension === "docx") {
        return docicon;
      } else if (fileExtension === "xlsx") {
        return excelicon;
      } else {
        return pdffile;
      }
    } else {
      return pdffile;
    }
  };
  //document icon display logic end

  //this below function for add folder   popup start//
  const [openmatchpdf, setOpenmatchpdf] = React.useState(false);
  const activematchpdf = () => setOpenmatchpdf(true);
  const handleClosematchpdf = () => setOpenmatchpdf(false);
  //this below function for add brain   popup end//

  return (
    <>
      <div>
        <div className="pdfView_wrapper  " style={{ display: "block" }}>
          <div className="pdfView_head">
            <div className="pdf_title">
              <div className="filenumbers">
                <Link to="#" onClick={toggleDrawer}>
                  <span>{props.pdfList?.length ? `1 of ${props.pdfList?.length} files` : "Select File"}</span>

                  <ExpandMoreIcon />
                </Link>
              </div>

              <span>-</span>

              <h2>{props.pdf?.file_name ? props.pdf?.file_name : "No Files Selected"}</h2>
            </div>

            <div className="viewer-actions">
              {props?.ocrData && (
                <div className="match_pdf_button tool-item">
                  <button type="button" className="btn btn-secondary" onClick={activematchpdf}>
                    {" "}
                    OCR{" "}
                  </button>
                </div>
              )}

              <div className="library_pdf_close" style={{ marginLeft: "10px" }}>
                <Tooltip className="blue-tooltip" title="Close Pdf" TransitionComponent={Zoom} placement="top" arrow>
                  <IconButton className=" " onClick={props.closePdfDrawer}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>

          <div className="pdfView_body">
            <div className="match_PDF_scroller">
              {props.pdfLoading && (
                <div className="pdf_content_loader">
                  <ContentLoader />
                </div>
              )}
              {props.pdfLoading === false && props?.pdf && isPdfSelected && (
                <Worker workerUrl={`//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`}>
                  <Viewer onDocumentLoad={() => {props?.setPageLoaded(true);}} fileUrl={props?.pdf?.file_path} defaultScale={SpecialZoomLevel.PageFit} plugins={[defaultLayoutPluginInstance, pageNavigationPluginInstance, searchPluginInstance]} />
                </Worker>
              )}
            </div>
            {searchText && (
              <div className="replychat_button">
                <motion.div
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    duration: 0.8,
                    delay: 0.5,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className="replychat_animationbutton"
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      props?.setSelectedText(searchText);
                      setSearchText("");
                    }}
                  >
                    {" "}
                    Chat with Selection!{" "}
                  </button>
                </motion.div>
              </div>
            )}
          </div>

          {props?.pdf && isPdfSelected === false && isWebsiteUrl === false && (
            <div className="pdfView_body">
              <DocViewer key={viewerKey} documents={docs} pluginRenderers={DocViewerRenderers} />
            </div>
          )}
          {website && isPdfSelected === false && isWebsiteUrl === true && (
           
            <div className="pdfView_body">
           <div className="Chart_pdf_scroller">
              <Iframe url={website?.knowledge?.url} position="absolute" width="100%" id="myId" className="myClassname" height="100%" styles={{ height: "100%" }} />
              </div>
            </div>
          )}

          <div className={`pdf_list_drawer ${isOpen ? "open" : ""}`}>
            <div className="pdf_drawer_head">
              <h4>Files available for selection : {props.pdfList?.length}</h4>

              <Link to="#" className=" pdfclose_button" onClick={closeDrawer}>
                X
              </Link>
            </div>
            <div className="pdf_list_body">
              <List dense sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
                {props?.pdfList &&
                  props.pdfList.length > 0 &&
                  props.pdfList.map((pdf, index) => {
                    const isLastItem = index === props.pdfList.length - 1;

                    return (
                      <ListItem
                        key={index}
                        onClick={() => {
                          if (pdf.knowledge.doc_type !== "url") {
                            props.getSignedPdf(pdf.knowledge._id);
                          }
                          setSelectedPdf(pdf);
                          closeDrawer();
                        }}
                        disablePadding
                      >
                        <ListItemButton selected={pdf?.knowledge?._id === selectedpdf?.knowledge?._id || (selectedpdf === null ? isLastItem : false)}>
                          <ListItemAvatar sx={{ minWidth: "auto", marginRight: "15px" }}>
                            <Avatar
                              src={getIcon(pdf?.knowledge?.file_name ? pdf.knowledge?.file_name : null, pdf?.knowledge?.doc_type ? pdf.knowledge.doc_type : null)}
                              sx={{
                                minWidth: "auto",
                                width: "25px",
                                height: "25px",
                              }}
                            />
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              pdf?.knowledge?.file_name
                                ? pdf.knowledge.file_name
                                : pdf?.knowledge?.url
                                ? pdf.knowledge.url.length > 35
                                  ? `${pdf.knowledge.url.substring(0, 35)}...`
                                  : pdf.knowledge.url
                                : "NA"
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
                {props.pdfList && props.pdfList.length === 0 && (
                  <ListItem disablePadding>
                    <ListItemButton>
                      <ListItemAvatar sx={{ minWidth: "auto", marginRight: "15px" }}>
                        <Avatar src={nopdf} sx={{ minWidth: "auto", width: "25px", height: "25px" }} />
                      </ListItemAvatar>
                      <ListItemText primary={"No Files Available"} />
                    </ListItemButton>
                  </ListItem>
                )}
              </List>
            </div>
          </div>
          {!props.pdf && props?.pdfList && props?.pdfList.length === 0 && props.pdfLoading === false && (
            <div className="pdfView_wrapper  pdfempatysection " style={{ display: "flex" }}>
              <div className="no_content-wrapper ">
                <div className="no-content-box">
                  <div className="no_content-icon">
                    <img src={nogenfile} alt="" height={100} />
                  </div>
                  <div className="no_content-title"> No Files </div>
                  <div className="no_content-pera">
                    <span> Please select the file to view here </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <MatchPdf name={props?.pdf?.file_name} openmatchpdf={openmatchpdf} handleClosematchpdf={handleClosematchpdf} url={props?.pdf?.file_path} ocrData={props?.ocrData} />
      </div>
    </>
  );
});
export default ReactPdf;
